import {ModalsProvider} from '@mantine/modals';
import React, {Fragment} from 'react';
import ReactDOM from 'react-dom/client';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import {ZINDEX_FLOATING_UI} from 'styles/StyleConstants';

export const MANTINE_MODALS_PROVIDER_ID = 'benchling-mantine-modals-provider';

/** Mounts a dedicated React root that owns the Mantine Modal Provider for the page. */
export function initModalsProvider(root: ReactDOM.Root | null): ReactDOM.Root {
  const modalContainer = document.createElement('div');
  modalContainer.className = 'mantine-modals-provider';
  modalContainer.id = MANTINE_MODALS_PROVIDER_ID;
  document.body.appendChild(modalContainer);
  return renderToDOM(
    <ModalsProvider modalProps={{zIndex: ZINDEX_FLOATING_UI}}>
      <Fragment />
    </ModalsProvider>,
    modalContainer,
    root
  );
}
